import React from "react"
import { Location } from "@reach/router"
import { useStaticQuery, graphql } from "gatsby"

import Meta from "./meta"

export default (props) => {
  const {
    site: { siteMetadata: metaSite },
  } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          lang
          name
          title
          titlePattern
          description
          robotsNoFollow
          robotsNoIndex
          socialImage
          fbAppId
          twitterHandle
          favIcon
          appleTouchIcon
          appleStatusBarStyle
          appleWebAppCapable
          msTileIcon
          msTileColor
        }
      }
    }
  `)

  return (
    <Location>
      {({ location }) => (
        <Meta {...props} metaSite={metaSite} location={location} />
      )}
    </Location>
  )
}
